import React, { useContext, useEffect, useState } from 'react';
import { SprawneMiastoContext } from '../../components/SprawneMiastoContext';
import { useNavigate } from 'react-router-dom';
import { IDistrict } from '../../models';

export default function SelectArea() {
    const Context = useContext(SprawneMiastoContext);
    const [areas, setAreas] = useState<{ administrator: IDistrict[]; moderator: IDistrict[] }>({
        administrator: [],
        moderator: [],
    });
    const navigate = useNavigate();

    const user = Context?.user;

    async function fetchAreas() {
        if (user?.userAdministrativeAreas.length === 0) {
            return navigate('/');
        }
        if (user?.userAdministrativeAreas.length === 1) {
            return navigate(`/adminCenter/${user.userAdministrativeAreas[0]}`);
        }
    }

    useEffect(() => {
        fetchAreas();
    }, []);

    //TODO: Dodać wybór obszaru dla administratora i moderatora
    return <div></div>;
}
